import React from 'react';
import Flexbox from 'flexbox-react';
import { css } from 'emotion';
import ProcessField from 'components/core/fields/ProcessField';
import InfoBoxLabel from 'components/core/InfoBoxLabel';
import RIEToggle from 'components/core/editable/RIEToggle';
import RIEInput from 'components/core/editable/RIEInput';
import InfoMessages from 'components/core/help/InfoMessages';
import DeprecateProcessForm from 'components/core/forms/DeprecateProcessForm';
import ModalsService from 'services/ModalsService';
import ProcessService from 'services/ProcessService';
import ProcessUtils from 'utils/ProcessUtils';

export default class ProcessDeprecatedField extends ProcessField {

    static propTypes = Object.assign({
    }, ProcessField.propTypes);

    onChange = (fieldPath, value) => {
        let formComponent = null;
        const process = this.props.process;
        const processId = this.props.process.name;
        const formRefFunction = (component) => { formComponent = component; };
        const modalTitle = 'Deprecate Process';

        const onOk = () => {
            const textValue = formComponent.getValue();
            const editor = ProcessUtils.getEditor(process)

            if (!textValue) {
                formComponent.setInvalid('Describing reason for deprecating process is required');
                return false;
            }

            editor.updateField(['deprecated'], value);
            editor.updateField(['deprecated_text'], textValue);
            editor.commit()
            ProcessService.saveProcess(processId);
        }

        ModalsService.openModal({
            id: 'deprecate_process',
            modalType: ModalsService.TYPE_CONFIRM,
            modalTitle,
            modalMessage: <DeprecateProcessForm ref={formRefFunction}/>,
            onOk
        });
    };

    render() {
        const process = this.props.process;

        if (process.production) {
            return (
                <React.Fragment>
                    <Flexbox flexDirection="row" alignItems="flex-start">
                        <InfoBoxLabel
                            label="Deprecated"
                            message={InfoMessages.deprecated}
                        />
                        <RIEToggle
                            value={process.deprecated}
                            fieldPath={['deprecated']}
                            change={this.onChange}
                            isDisabled={!this.props.hasWritePermissions}
                            radioGroupName="deprecatedRadio"
                            processId={process.name}
                        />
                    </Flexbox>
                    {process.deprecated &&
                        <Flexbox flexDirection="row" className={css`margin:10px 0px 0px 50px;`}>
                            <InfoBoxLabel
                                label="Reason"
                                infoIcon={false}
                            />
                            <RIEInput
                                value={process.deprecated_text}
                                fieldPath={['deprecated_text']}
                                change={this.onChange}
                                process={process}
                                processId={process.name}
                                processErrors={this.props.processErrors}
                                isDisabled={!this.props.hasWritePermissions}
                                className={css`margin-top:8px`}
                            />
                        </Flexbox>
                    }
                </React.Fragment>
            );
        }

        return null;
    }
}



// WEBPACK FOOTER //
// ./src/components/core/fields/ProcessDeprecatedField.js